module.exports = __webpack_public_path__ + "static/media/upi_message_fail.5d95b8bc.svg";